import React, { useState } from 'react'
import { ConfirmDialog } from './ConfirmDialog'
import './ProfilePanel.css'

export const ProfilePanel = ({ userInfo, onLogout }) => {
  const [avatarError, setAvatarError] = useState(false)
  const [showLogoutDialog, setShowLogoutDialog] = useState(false)

  if (!userInfo) return null

  const initials = (() => {
    const name = userInfo.name || userInfo.email?.split('@')[0] || ''
    return name.charAt(0).toUpperCase() || '?'
  })()

  return (
    <div className="profile-panel">
      <ConfirmDialog
        isOpen={showLogoutDialog}
        onClose={() => setShowLogoutDialog(false)}
        onConfirm={onLogout}
        title="Logout"
        message="Are you sure you want to log out?"
        confirmText="Logout"
        cancelText="Cancel"
        variant="danger"
      />

      <div className="profile-card">
        {userInfo.avatar && !avatarError ? (
          <img
            src={userInfo.avatar}
            alt={userInfo.name || 'User'}
            className="profile-avatar-img"
            referrerPolicy="no-referrer"
            onError={() => setAvatarError(true)}
          />
        ) : (
          <div className="profile-avatar-initials">{initials}</div>
        )}
        <div className="profile-name">{userInfo.name}</div>
        <div className="profile-email">{userInfo.email}</div>
      </div>

      {onLogout && (
        <button className="profile-logout-btn" onClick={() => setShowLogoutDialog(true)}>
          Logout
        </button>
      )}
    </div>
  )
}
